/* eslint-disable */
import React, { Component } from "react";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import LeftMenu from "./LeftMenu";
import userImage from "../../assets/images/users/21.jpg"
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const script = document.createElement("script");
    script.src = "/assets/plugins/sidemenu/sidemenu.js";
    script.async = true;
    document.body.appendChild(script);

    const script2 = document.createElement("script");
    script2.src = "/assets/plugins/p-scroll/pscroll.js";
    script2.async = true;
    document.body.appendChild(script2);

    const script3 = document.createElement("script");
    script3.src = "/assets/js/custom.js";
    script3.async = true;
    document.body.appendChild(script3);
  }

  render() {
    var currentPage = this.props.currentPage;
    return (
      <div>
        <div className="app-header header sticky">
          <div className="container-fluid main-container">
            <div className="d-flex">
              <a
                aria-label="Hide Sidebar"
                className="app-sidebar__toggle"
                data-bs-toggle="sidebar"
                href={void 0}
              ></a>

              <a className="logo-horizontal " href="index.html">
                <img
                  src="../assets/images/brand/logo.png"
                  className="header-brand-img desktop-logo"
                  alt="logo"
                />
                <img
                  src="../assets/images/brand/logo-3.png"
                  className="header-brand-img light-logo1"
                  alt="logo"
                />
              </a>
              <div className="d-flex order-lg-2 ms-auto header-right-icons">
                <button
                  className="navbar-toggler navresponsive-toggler d-lg-none ms-auto"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent-4"
                  aria-controls="navbarSupportedContent-4"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon fe fe-more-vertical"></span>
                </button>
                <div className="navbar navbar-collapse responsive-navbar p-0">
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent-4"
                  >
                    <div className="d-flex order-lg-2">
                      <div className="dropdown d-lg-none d-flex">
                        <a
                          href={void 0}
                          className="nav-link icon"
                          data-bs-toggle="dropdown"
                        >
                          <i className="fe fe-search"></i>
                        </a>
                        <div className="dropdown-menu header-search dropdown-menu-start">
                          <div className="input-group w-100 p-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search...."
                            />
                            <div className="input-group-text btn btn-primary">
                              <i
                                className="fa fa-search"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="dropdown d-flex">
                        <a className="nav-link icon full-screen-link nav-link-bg">
                          <i className="fe fe-minimize fullscreen-button"></i>
                        </a>
                      </div>
                      {/*
                      <div className="dropdown  d-flex notifications">
                        <a className="nav-link icon" data-bs-toggle="dropdown">
                          <i className="fe fe-bell"></i>
                          <span className=" pulse"></span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <div className="drop-heading border-bottom">
                            <div className="d-flex">
                              <h6 className="mt-1 mb-0 fs-16 fw-semibold text-dark">
                                Notifications
                              </h6>
                            </div>
                          </div>
                          <div className="notifications-menu">
                            <a
                              className="dropdown-item d-flex"
                              href="notify-list.html"
                            >
                              <div className="me-3 notifyimg  bg-primary brround box-shadow-primary">
                                <i className="fe fe-mail"></i>
                              </div>
                              <div className="mt-1 wd-80p">
                                <h5 className="notification-label mb-1">
                                  New Application received
                                </h5>
                                <span className="notification-subtext">
                                  3 days ago
                                </span>
                              </div>
                            </a>
                            <a
                              className="dropdown-item d-flex"
                              href="notify-list.html"
                            >
                              <div className="me-3 notifyimg  bg-secondary brround box-shadow-secondary">
                                <i className="fe fe-check-circle"></i>
                              </div>
                              <div className="mt-1 wd-80p">
                                <h5 className="notification-label mb-1">
                                  Project has been approved
                                </h5>
                                <span className="notification-subtext">
                                  2 hours ago
                                </span>
                              </div>
                            </a>
                            <a
                              className="dropdown-item d-flex"
                              href="notify-list.html"
                            >
                              <div className="me-3 notifyimg  bg-success brround box-shadow-success">
                                <i className="fe fe-shopping-cart"></i>
                              </div>
                              <div className="mt-1 wd-80p">
                                <h5 className="notification-label mb-1">
                                  Your Product Delivered
                                </h5>
                                <span className="notification-subtext">
                                  30 min ago
                                </span>
                              </div>
                            </a>
                            <a
                              className="dropdown-item d-flex"
                              href="notify-list.html"
                            >
                              <div className="me-3 notifyimg bg-pink brround box-shadow-pink">
                                <i className="fe fe-user-plus"></i>
                              </div>
                              <div className="mt-1 wd-80p">
                                <h5 className="notification-label mb-1">
                                  Friend Requests
                                </h5>
                                <span className="notification-subtext">
                                  1 day ago
                                </span>
                              </div>
                            </a>
                          </div>
                          <div className="dropdown-divider m-0"></div>
                          <a
                            href="notify-list.html"
                            className="dropdown-item text-center p-3 text-muted"
                          >
                            View all Notification
                          </a>
                        </div>
                      </div> */}
                      <div className="dropdown d-flex profile-1">
                        <a
                          href={void 0}
                          data-bs-toggle="dropdown"
                          className="nav-link leading-none d-flex"
                        >
                          <img
                            src={userImage}
                            alt="profile-user"
                            className="avatar  profile-user brround cover-image"
                          />
                        </a>
                        <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <div className="drop-heading">
                            <div className="text-center">
                              <h5 className="text-dark mb-0 fs-14 fw-semibold">
                                {cookie.load("name") || ""}
                              </h5>
                            </div>
                          </div>
                          <div className="dropdown-divider m-0"></div>
                          <Link
                            className="dropdown-item"
                            to={"/changepassword"}
                          >
                            <i className="dropdown-icon fa fa-key"></i> Change
                            Password
                          </Link>
                          <Link className="dropdown-item" to={"/logout"}>
                            <i className="dropdown-icon fe fe-alert-circle"></i>{" "}
                            Sign out
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <LeftMenu currentPage={currentPage} />
      </div>
    );
  }
}

export default Header;
